/**
 * Event list component
 */
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import {IEvent, IEventManagerConfig} from '../../Interfaces/index';
import {sortBy, get} from 'lodash';
import moment from 'moment';
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'ispm-pan-cancer-events-list',
  templateUrl: './events-list.component.html',
  styleUrls: ['./events-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventsListComponent implements OnInit, OnChanges {
  eventTypes: any;
  showEventsPanel: boolean = true;
  @Input() config: IEventManagerConfig;
  public addEventAvailable: boolean = true;
  private eventsSelected: number = 0;
  public deleteEventAvailable: boolean = true;
  public locale: string;
  public expandAll: boolean = false;

  @Input() eventCategories: any;

  @Input() selectedEvent: IEvent;
  @Output() onChangeEvent: EventEmitter<IEvent> = new EventEmitter();
  @Output() onChangeTogglePanel: EventEmitter<boolean> = new EventEmitter();
  @Output() onCreateEvent: EventEmitter<any> = new EventEmitter();
  @Output() onDeleteEvent: EventEmitter<IEvent> = new EventEmitter();
  @Output() onSelectEvent: EventEmitter<any> = new EventEmitter();

  @Input() changeSelectedEvent: (event: IEvent) => void;
  @Input() totalEvents: number;
  @Input() showEventsGroup: boolean = true;
  @Input() isEditable: boolean = false;
  load: boolean = true;

  constructor(private _translateService: TranslateService,) {

  }

  ngOnInit() {
    if(get(this.config,'showAddButton') === false) {
      this.addEventAvailable = false;
      this.deleteEventAvailable = false;
    }
    if (get(this.config, 'showMiniEventList')) {
      this.showEventsPanel = false;
      this.onChangeTogglePanel.emit(this.showEventsPanel);
    }
    if (get(this.config, 'expandAll')) {
      this.expandAll = true;
    }
    this.locale = this._translateService.currentLang;
  }

  /**
   * On click event
   * @param clickedEvent
   */
  suggestionWasClicked(clickedEvent: IEvent): void {
    this.onChangeEvent.emit(clickedEvent);
  }
  /**
   * Toggle side panel
   */
  showHideEventsPanel() {
    this.showEventsPanel = !this.showEventsPanel;
    this.onChangeTogglePanel.emit(this.showEventsPanel);
  }

  /**
   * Emit create new event emitter
   */
  createNewEvent() {
    this.onCreateEvent.emit();
  }

  /**
   * Emit delete event emitter
   */
  deleteEvent(event: IEvent) {
    this.onDeleteEvent.emit(event);
  }

  /**
   *
   */

  selectEvent(event:IEvent, selection: boolean) {
    if (!selection) {
      this.eventsSelected--;
    }
    this.onSelectEvent.emit({event: event, selection: selection});
  }

  isEventSelectionDisabled(selection) {
    if(!this.isEditable) {
      return true;
    }
    if (this.eventsSelected >= get(this.config, 'maxEventSelection') && !selection) {
      return true;
    }
    return false;
  }

  prepareEvents() {
    if (this.eventCategories) {
      this.eventTypes = [];
      this.eventsSelected = 0
      if (this.showEventsGroup) {
        this.eventCategories.forEach((v, k) => {
          const events = sortBy(v, function (o) {
            if (o.selected) {
              this.eventsSelected++;
            }
            return moment(o.date).format('YYYYMMDDhhmmss');
          }.bind(this)).reverse();
          this.eventTypes.push({
            key: k,
            val: events
          });
        });
        this.eventTypes = sortBy(this.eventTypes, ['key']).reverse();
      } else {
        this.eventCategories.forEach(event => {
          if (event.selected) {
            this.eventsSelected++;
          }
        });
      }
    }
  }

  /**
   * on change of event lists
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'eventCategories':
            this.prepareEvents();
            break;
        }
      }
    }
  }
}
